import { useEffect, useRef, useState } from 'react';
import crosssimgiocn from "../../Images/crosssimgiocn.png"
import Neoologoasjji from "../../Images/Neoologoasjji.png";
import postbanneimmhg from "../../Images/cameralogo.png";
import Ownpostpagemodal from '../../Modal/Ownpostpagemodal';
import { formatDateAgo } from '../../utils/Helper';
import { useDispatch, useSelector } from 'react-redux';
import ItemLoader from '../../Component/ItemLoader';
import { useNavigate } from 'react-router-dom';
import { deletePostEnquiry, fetchPostEnquiries } from '../../Redux/Slice/EnquirySlice';
import moment from 'moment';
import PostSummary from "./components/PostSummary";

const BlmPostEnquiries = ({ filter, setCounter }) => {
    const { status, PostEnquiries } = useSelector((state) => state.enquiry);
    const { UserProfileID } = useSelector((state) => state.app);
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [handleownpostmodal, sethandleownpostmodal] = useState(false)
    const [threedpotsspclmodal, setThreedpotsspclmodal] = useState(false);
    const [selectedPostData, setSelectedPostData] = useState()
    const handleopwmnpostmodal = (e, item) => {
        e.preventDefault()
        setSelectedPostData(item)
        sethandleownpostmodal(!handleownpostmodal)
    }

    const [visibleItems, setVisibleItems] = useState([]);
    const [itemsToShow, setItemsToShow] = useState(3);

    useEffect(() => {
        UserProfileID ? dispatch(fetchPostEnquiries()) : navigate('/user-login')
    }, [])

    useEffect(() => {
        const today = new Date();
        if (filter === "today") {
            const todayString = today.toISOString().split("T")[0];
            setVisibleItems(
                [...PostEnquiries]
                    .filter((post) => {
                        // Extract only the date part from createdOn
                        const createdDate = post.createdOn.split("T")[0];
                        return createdDate === todayString;
                    })
                // .slice(0, itemsToShow)
            )
        } else if (filter === "week") {
            // Get the first day of the current week (Sunday)
            const startOfWeek = new Date(today);
            startOfWeek.setDate(today.getDate() - today.getDay());
            startOfWeek.setHours(0, 0, 0, 0); // Set to start of the day

            // Get the last day of the current week (Saturday)
            const endOfWeek = new Date(startOfWeek);
            endOfWeek.setDate(startOfWeek.getDate() + 6);
            endOfWeek.setHours(23, 59, 59, 999); // Set to end of the day

            setVisibleItems(
                [...PostEnquiries]
                    .filter((post) => {
                        const createdDate = new Date(post.createdOn);
                        return createdDate >= startOfWeek && createdDate <= endOfWeek;
                    })
                // .slice(0, itemsToShow)
            )
        } else if (filter === "month") {
            const currentMonth = today.getMonth(); // 0-based index (0 = January)
            const currentYear = today.getFullYear();

            setVisibleItems([...PostEnquiries]
                .filter((post) => {
                    const createdDate = new Date(post.createdOn);
                    return (
                        createdDate.getMonth() === currentMonth && createdDate.getFullYear() === currentYear
                    );
                })
                // .slice(0, itemsToShow)
            )
        } else {
            setVisibleItems(
                [...PostEnquiries]
                // .slice(0, itemsToShow)
            )
        }
    }, [itemsToShow, PostEnquiries, filter]);

    useEffect(() => {
        setCounter(visibleItems.length)
    }, [visibleItems])

    const divRef = useRef(null);
    const handleClickOutside = (e) => {
        if (divRef.current && !divRef.current.contains(e.target)) {
            setThreedpotsspclmodal(false)
        }
    };

    useEffect(() => {
        // Add event listener when the component mounts
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // Cleanup the event listener when the component unmounts
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const openModal = (image) => {
        setSelectedImage(image);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setSelectedImage(null);
        setIsModalOpen(false);
    };

    const [actDelete, setActDelete] = useState(false)
    const deleteEnquiry = async (e, id) => {
        e.preventDefault()
        setActDelete(true)
        dispatch(deletePostEnquiry(id))
        dispatch(fetchPostEnquiries())
    }

    return (
        <>
            {status === "loading" && !actDelete ? (<ItemLoader />) : (
                <>
                    <div className='allpostowndmaimndivmain'>
                        {
                            visibleItems.map((enquiryItem, index) => {
                                return (
                                    <>
                                        <div className='allpostowndmaimndiv' key={index}>
                                            <div className='allpostowndmaimndivallelemnt'>
                                                <div className='allpostimagedesuigfnatinob' style={{ marginBottom: "10px", paddingBottom: "5px", }}>
                                                    <div className='allposttslodjjimg' style={{ cursor: "pointer" }} onClick={(e) => handleopwmnpostmodal(e, enquiryItem?.PostData)}>
                                                        <img src={enquiryItem?.PostData?.file || Neoologoasjji} alt='...' />

                                                    </div>
                                                    <div className='' style={{ cursor: "pointer" }} onClick={(e) => handleopwmnpostmodal(e, enquiryItem?.PostData)}>
                                                        <h4 className='neeporoalposttsheadr'>{enquiryItem?.PostData?.subject}</h4>
                                                        <p className='cmskshhstdiifgysyttxtpop'>{moment(enquiryItem?.PostData?.createdOn).format('DD-MMM-YYYY')}</p>
                                                    </div>
                                                </div>

                                                <div className='crosasddoproidikdsjbhidivflx'>
                                                    <div className='crossidovpostimgdiv' onClick={(e) => deleteEnquiry(e, enquiryItem?._id)}>
                                                        <img src={crosssimgiocn} alt='...' />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='postbannettimhdivflxmakflx mt-4'>
                                                <div className='poosttalouindtdettstctpopdoiv'>
                                                    <p><strong>Name:</strong> {enquiryItem?.name}</p>
                                                    <p><strong>Email:</strong> {enquiryItem?.workEmail}</p>
                                                    <p> <strong>Phone:</strong> {enquiryItem?.phoneNo || enquiryItem?.mobile}</p>
                                                    <p><strong>Enquiry Type: </strong>{enquiryItem?.typeOfEnquiry || ""}</p>
                                                    <p><strong>Subject:</strong> {enquiryItem?.enquirySubject || "..."}</p>
                                                    <p><strong>Message:</strong>{enquiryItem?.enquiry || "..."} </p>
                                                    {
                                                        enquiryItem?.file &&
                                                        <div className='_postbanneimmhgdivjakhjimh' onClick={() => openModal(enquiryItem?.file || postbanneimmhg)} >
                                                            <img src={enquiryItem?.file || postbanneimmhg} alt='' style={{ borderRadius: "8px", cursor: "pointer", maxWidth: "64px" }} />
                                                        </div>
                                                    }
                                                </div>

                                            </div>
                                            <PostSummary data={enquiryItem?.PostData} onOpen={(e) => handleopwmnpostmodal(e, enquiryItem?.PostData)} />
                                            <div className=''>
                                                <p className='htrrstrtdttgsgbtxttppgh'>{formatDateAgo(enquiryItem?.createdOn)}</p>
                                            </div>
                                        </div>

                                    </>
                                )
                            })
                        }
                        {handleownpostmodal && <Ownpostpagemodal closemodal={sethandleownpostmodal} data={selectedPostData} />}

                    </div>

                    {isModalOpen && (
                        <div
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100vw",
                                height: "100vh",
                                backgroundColor: "rgba(0, 0, 0, 0.8)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 1000,
                            }}
                            onClick={closeModal}
                        >
                            <img
                                src={selectedImage}
                                alt="Large View"
                                style={{
                                    maxWidth: "90%",
                                    maxHeight: "90%",
                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.5)",
                                }}
                            />
                        </div>
                    )}
                </>
            )
            }

        </>
    )
}

export default BlmPostEnquiries
